import { ThemeColorSchemeType } from '@/stores/builder';

type ColorSchemePreviewProps = {
  scheme: ThemeColorSchemeType;
};

export default function ThemeColorPreview({ scheme }: ColorSchemePreviewProps) {
  return (
    <>
      <div className='background_color flex flex-col items-center justify-center rounded-md border px-3 py-2'>
        <div className='text_color mb-1 text-base font-bold'>Aa</div>
        <div className='mx-auto flex w-full max-w-[60px] gap-x-1'>
          <div className='btn_solid_background h-3 w-full rounded-full'></div>
          <div className='btn_outline h-3 w-full rounded-full border'></div>
        </div>
      </div>
      <style jsx>
        {`
          .background_color {
            background-color: ${scheme.background};
          }
          .text_color {
            color: ${scheme.text};
          }
          .btn_solid_background {
            background-color: ${scheme.btnSolidBackgroud};
          }
          .btn_outline {
            border-color: ${scheme.btnOutline};
          }
        `}
      </style>
    </>
  );
}
